export enum TabName {
  TODOS = 'todos',
  ARCHIVED = 'archived',
  DRAFTS = 'activeDrafts',
  COMPLETED = 'completed',
  DISCOVERY = 'discovery',
  IN_PROGRESS = 'inProgress',
  SUBMISSIONS = 'submissions',
}

export const initialDashboardSummary = {
  [TabName.IN_PROGRESS]: {
    totalCount: 0,
    closingSoonCount: 0,
  },
  [TabName.DISCOVERY]: {
    totalCount: 0,
  },
  [TabName.DRAFTS]: {
    totalCount: 0,
    dueSoonCount: 0,
  },
  [TabName.TODOS]: {
    totalCount: 0,
  },
  [TabName.SUBMISSIONS]: {
    totalCount: 0,
    revisionNeededCount: 0,
    pendingApprovalCount: 0,
    recentlyApprovedCount: 0,
  },
  [TabName.COMPLETED]: {
    totalCount: 0,
    withCertificateCount: 0,
  },
  [TabName.ARCHIVED]: {
    totalCount: 0,
  },
};

export type DashboardSummary = typeof initialDashboardSummary;

export type DashboardSummaryState = {
  isSummaryLoading: boolean;
  /** True once the first successful fetch has completed. Guards against reacting to the all-zero initial state. */
  onceLoaded: boolean;
  summary: DashboardSummary;
};

export const initialDashboardSummaryState: DashboardSummaryState = {
  isSummaryLoading: false,
  onceLoaded: false,
  summary: initialDashboardSummary,
};
